<form class="form" [formGroup]="form">
  <div formArrayName="listItems" class="contacts-custom-list">
    <header [options]="headerOptions"></header>

    <tui-scrollbar class="list-wrapper" cdkScrollable>
      <div
        cdkDropList
        [cdkDropListOrientation]="'vertical'"
        [cdkDropListLockAxis]="'y'"
        [cdkDropListAutoScrollStep]="10"
        [cdkDropListAutoScrollDisabled]="false"
        (cdkDropListDropped)="moveListItem($event)"
      >
        <ng-container *ngFor="let item of listItemsControl?.controls; let cIndex = index">
          <div cdkDrag class="item" [formGroupName]="cIndex">
            <div class="custom-placeholder" *cdkDragPlaceholder></div>

            <list-item-edit formControlName="title"></list-item-edit>
          </div>
          <div class="separator"></div>
        </ng-container>
      </div>
    </tui-scrollbar>

    <footer [options]="footerOptions"></footer>
  </div>
</form>
